<template>
  <div
    v-click-outside="handleCloseMenu"
    :class="['language-selector', { ['language-selector--dark']: isDarkTheme }]"
  >
    <ShButton
      :naked="true"
      aria-haspopup="true"
      :aria-expanded="isOpen"
      @click="handleOpenMenu"
      @focus="handleOpenMenu"
      @blur="handleCloseMenu"
    >
      <span class="language-selector__selected">{{ selected }}</span>
      <ShIcon
        :class="['language-selector__arrow', { ['language-selector--open']: isOpen }]"
        size="xsmall"
        name="arrowBottom"
        :invert="isDarkTheme"
      />
    </ShButton>
    <div v-show="isOpen" class="language-selector__popup">
      <ul class="language-selector__list">
        <NavigationItem
          v-for="locale in canLanguageSwitch"
          class="language-selector__item"
          :key="locale.code"
        >
          <ShButton
            :thin-text="true"
            :naked="true"
            tabindex="0"
            @click="handleSelectLocale(locale.code)"
          >
            {{ locale.t }}
          </ShButton>
        </NavigationItem>
      </ul>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import { ShIcon, ShButton, NavigationItem } from '@sohohouse/design-system'

const { mapGetters: mapJssGetters } = createNamespacedHelpers('jss')
const { mapState: mapEnvState, mapGetters: mapEnvGetters } = createNamespacedHelpers('ui/environment')

export default {
  name: 'LanguageSelector',

  components: {
    ShIcon,
    ShButton,
    NavigationItem
  },

  data () {
    return {
      isOpen: false
    }
  },

  computed: {
    ...mapJssGetters(['isEditMode']),
    ...mapEnvState(['languages']),
    ...mapEnvGetters(['isDarkTheme']),

    currentLocale () {
      return this.$i18n.locale
    },

    canLanguageSwitch () {
      return this.languages.filter(({ code }) => code !== this.currentLocale)
    },

    selected () {
      const selected = this.languages.find(({ code }) => code === this.currentLocale)
      return (selected && selected.t) || ''
    }
  },

  methods: {
    handleOpenMenu () {
      this.isOpen = true
    },

    handleCloseMenu () {
      this.isOpen = false
    },

    handleSelectLocale (code) {
      this.$i18n.setLocaleCookie(code)
      this.$router.push(this.switchLocalePath(code))
      this.handleCloseMenu()
    }
  }
}
</script>

<style lang="scss" scoped>
.language-selector {
  position: relative;
  // allows click for touchable devices
  cursor: pointer;
  width: fit-content;

  &__popup {
    position: absolute;
    bottom: 125%;
    background: $color-white;
    border: 1px solid $color-slate-gray;
    border-radius: 4px;
    display: flex;
    flex-grow: 1;
  }

  &__list {
    margin: 0;
    padding: $space-050 $space-060;
  }

  &__selected {
    @include font('040')
  }

  &__item button{
    @include font('050')
  }

  &__globe {
    margin-right: $space-030;
  }

  &__arrow {
    margin-left: $space-030;
    transition: all 300ms;
  }

  &--open {
    transform: rotate(180deg);
  }

  &--dark {
    background: $color-black;
    color: $color-white;

    .language-selector__popup {
      background-color: $color-black;
    }

    .language-selector__item button {
      color: $color-white;
    }
  }
}
</style>
